import { makeStyles } from '@material-ui/core/styles';


export const styles = makeStyles(() => ({
  datepicker: ({ fullWidth }) => ({
    ...(fullWidth ? { width: '100%' } : {}),
  }),
}));
